import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgServiceConsulting32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M7.5 18.5H6.28C4.553 18.5 3 16.575 3 14.785v-.876C3 12.218 4.31 11.5 6.28 11.5H6.5l.003-.135C6.65 6.444 10.857 2.5 16 2.5c5.19 0 9.427 4.017 9.5 9h.72c1.97 0 3.28.718 3.28 2.409v.876c0 1.79-1.553 3.715-3.28 3.715h-.72v6.585c0 2.27-1.571 4.013-3.8 4.013H19.56l-.002.06c-.075.763-.766 1.342-1.586 1.342h-3.88c-.868 0-1.593-.65-1.593-1.479v-.042c0-.83.725-1.479 1.593-1.479h3.88c.52 0 .988.233 1.28.598H21.7c1.653 0 2.801-1.273 2.801-3.013V11.63C24.5 7.15 20.692 3.5 16 3.5c-4.682 0-8.484 3.633-8.5 8.101V18.5Zm10.473 10h-3.88c-.34 0-.593.227-.593.479v.042c0 .252.254.479.593.479h3.88c.339 0 .592-.227.592-.479v-.042c0-.252-.253-.479-.592-.479Zm-.935-22c2.964 0 6.462 2.703 6.462 5.913v6.42c0 4.028-3.362 7.293-7.5 7.293-4.137 0-7.5-3.217-7.5-7.19v-6.523c0-.653.785-1.113 1.434-1.113 3.286 0 5.646-1.176 6.195-3.903.118-.586.327-.897.909-.897Zm.077 1.001.004.011a.312.312 0 0 1-.01.083c-.666 3.307-3.47 4.705-7.175 4.705-.17 0-.434.155-.434.113v6.523c0 3.41 2.906 6.19 6.5 6.19 3.592 0 6.5-2.824 6.5-6.293v-6.42c0-2.514-2.822-4.771-5.236-4.907l-.149-.005ZM6.5 17.5v-5h-.22c-1.42 0-2.203.392-2.275 1.273L4 13.909v.876c0 1.28 1.158 2.715 2.28 2.715h.22Zm19.72-5h-.72v5h.72c1.122 0 2.28-1.436 2.28-2.715v-.876c0-.977-.789-1.409-2.28-1.409Z"
        className="service-consulting-32_svg__path-1"
      />
    </SvgIcon>
  );
};
const Memo = memo(SvgServiceConsulting32);
export default Memo;
